var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fast-tracking" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", {
      staticClass: "message",
      domProps: { innerHTML: _vm._s(this.$i18n("fast_tracking_message")) },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dot-container" }, [
      _c("span", { staticClass: "pulse" }, [
        _c("span", { staticClass: "pulse-blob" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }